import React from "react";
import Dot from "./Dot";

class TypingDots extends React.Component {
  constructor(props) {
    super(props);

    const { dotAmplitude, dotSpeed, dotY } = props;

    this.state = {
      currentAnimationTime: 0
    };

    this._animation = () => {
      this.setState(prevState => ({
        y1: dotY + dotAmplitude * Math.sin(prevState.currentAnimationTime),
        y2: dotY + dotAmplitude * Math.sin(prevState.currentAnimationTime - 1),
        y3: dotY + dotAmplitude * Math.sin(prevState.currentAnimationTime - 2),
        currentAnimationTime: prevState.currentAnimationTime + dotSpeed
      }));

      this.frameAnimationRequest = requestAnimationFrame(this._animation);
    };

    this.frameAnimationRequest = requestAnimationFrame(this._animation);
  }

  componentWillUnmount() {
    cancelAnimationFrame(this.frameAnimationRequest);
  }

  render() {
    const {
      dotStyles,
      style,
      dotColor,
      dotMargin,
      dotRadius,
      dotX
    } = this.props;

    return (
      <div
        style={{
          position: "relative",
          ...style
        }}
      >
        <Dot
          x={dotX - dotRadius - dotMargin}
          y={this.state.y1}
          radius={dotRadius}
          style={dotStyles}
          dotColor={dotColor}
        />
        <Dot
          x={dotX}
          y={this.state.y2}
          radius={dotRadius}
          style={dotStyles}
          dotColor={dotColor}
        />
        <Dot
          x={dotX + dotRadius + dotMargin}
          y={this.state.y3}
          radius={dotRadius}
          style={dotStyles}
          dotColor={dotColor}
        />
      </div>
    );
  }
}

TypingDots.defaultProps = {
  style: {},
  dotStyles: {},
  dotColor: "rgba(0, 0, 0, 0.5)",
  dotMargin: 8,
  dotAmplitude: 3,
  dotSpeed: 0.15,
  dotRadius: 4,
  dotY: 4,
  dotX: 12
};

export default TypingDots;
